import {logHelper, tLogStyled} from 'utils/Logger';
import {Object3D} from 'three/src/core/Object3D';
import {AnnotationData} from 'webgl/types/AnnotationData';

declare const annotationData: Array<AnnotationData>; // imported from /public/editableContent.js, so no need to be compiled

export const getAnnotationDataFromId__JSON = async (annotationId: string): Promise<AnnotationData> => {
  const description =
    annotationData.find(annotation => annotationId === annotation.key) || {key: annotationId};

  tLogStyled('[getAnnotationData__JSON()] using json data : annotation description', logHelper.warning, description);

  return new Promise<AnnotationData>((resolve) => {
    setTimeout(() => resolve(description), 0);
  });
};

export const getAnnotationData__JSON = async (annotationObject: Object3D): Promise<AnnotationData> => {
  const description =
    annotationData.find(annotation => annotationObject.userData.tags?.annotationId === annotation.key)
    || {key: annotationObject.userData.tags?.annotationId, notFound: true};

  tLogStyled('[getAnnotationData__JSON()] using json data : annotation description', logHelper.warning, description);

  return new Promise<AnnotationData>((resolve) => {
    setTimeout(() => resolve(description), 0);
  });
};

export const getAnnotationsData__JSON = async (annotationObjects: Object3D[]): Promise<AnnotationData[]> => {
  const descriptions = annotationData.filter(annotation =>
    annotationObjects.some(obj =>
      obj.userData.tags?.annotationId === annotation.key));

  tLogStyled('[getAnnotationsData__JSON()] using json data : fixed annotation descriptions', logHelper.warning, descriptions);

  return new Promise<AnnotationData[]>((resolve) => {
    setTimeout(() => resolve(descriptions), 0);
  });
};

// export const getAnnotationData__FAKE = async (annotationObject: Object3D): Promise<AnnotationData> => {
//   const description =
//     descriptions_FAKE.find(description => annotationObject.userData.tags?.annotationId === description.key) ||
//     {key: annotationObject.userData.tags?.annotationId};
//
//   tLogStyled('[getAnnotationDescriptions__FAKE()] using fake data : annotation description', logHelper.warning, description);
//
//   return new Promise<AnnotationData>((resolve) => {
//     setTimeout(() => resolve(description), 0);
//   });
// };
//
// export const getAnnotationsData__FAKE = async (annotationObjects: Object3D[]): Promise<AnnotationData[]> => {
//   const descriptions = descriptions_FAKE.filter(description =>
//     annotationObjects.some(obj =>
//       obj.userData.tags?.annotationId === description.key));
//
//   tLogStyled('[getAnnotationDescriptions__FAKE()] using fake data : fixed annotation descriptions', logHelper.warning, descriptions);
//
//   return new Promise<AnnotationData[]>((resolve) => {
//     setTimeout(() => resolve(descriptions), 0);
//   });
// };